export function contactUsForm() {
    $('select[name="lead_type"]').on('change', function(){
        var _service_type = cf_lead_type[$(this).val()];
        var _list_service_type = $('select[name="service_type"]');
        _list_service_type.empty();
        _list_service_type.append($("<option></option>").attr("value",'').text('What service category are you primarily interested in? *'));
        if (_service_type){
            $.each(_service_type, function(key,value) {
                _list_service_type.append($("<option></option>").attr("value",value).text(value));
            });
            _list_service_type.closest('.form-item').show();
            jcf.replaceAll();
        } else {
            _list_service_type.closest('.form-item').hide();
        }        
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/contact-us-page.js